/* eslint-disable */
import * as Types from '../../../models/schema';

import { ClassificationFragmentDTO } from '../../../graphql/models/fragments';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type CreateClassificationVariablesDTO = Types.Exact<{
  data: Types.ClassificationCreateInputDTO;
}>;


export type CreateClassificationDTO = (
  { __typename?: 'Mutation' }
  & { createOneClassification: (
    { __typename?: 'Classification' }
    & ClassificationFragmentDTO
  ) }
);


export const CreateClassificationDocumentDTO = gql`
    mutation createClassification($data: ClassificationCreateInput!) {
  createOneClassification(data: $data) {
    ...classificationFragment
  }
}
    ${ClassificationFragmentDTO}`;
export type CreateClassificationMutationFnDTO = Apollo.MutationFunction<CreateClassificationDTO, CreateClassificationVariablesDTO>;

/**
 * __useCreateClassification__
 *
 * To run a mutation, you first call `useCreateClassification` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClassification` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClassification, { data, loading, error }] = useCreateClassification({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClassification(baseOptions?: Apollo.MutationHookOptions<CreateClassificationDTO, CreateClassificationVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClassificationDTO, CreateClassificationVariablesDTO>(CreateClassificationDocumentDTO, options);
      }
export type CreateClassificationHookResult = ReturnType<typeof useCreateClassification>;
export type CreateClassificationMutationResultDTO = Apollo.MutationResult<CreateClassificationDTO>;
export type CreateClassificationMutationOptionsDTO = Apollo.BaseMutationOptions<CreateClassificationDTO, CreateClassificationVariablesDTO>;